module.exports = __webpack_public_path__ + "img/throw-mobile.ae04b9f5.png";